import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { uiTheme as t } from './theme';

export interface SectionGroupProps {
  /** Rótulo del grupo. Es una etiqueta, no un encabezado. */
  label: string;
  children: ReactNode;
}

const Wrapper = styled.section({
  maxWidth: 1120,
});

// Deliberadamente un párrafo y no un encabezado: rotula el grupo sin entrar a
// la jerarquía semántica del `PageHeader` de la pantalla.
const Label = styled.p({
  margin: '0 0 12px',
  fontFamily: t.font,
  fontSize: 12.5,
  fontWeight: 600,
  letterSpacing: '0.02em',
  color: t.color.muted,
});

/**
 * Composición de layout: rotula un conjunto de secciones dentro de un hub.
 * No sabe qué contiene; solo pone la etiqueta encima de sus hijos.
 */
const SectionGroup = ({ label, children }: SectionGroupProps) => (
  <Wrapper>
    <Label>{label}</Label>
    {children}
  </Wrapper>
);

export default SectionGroup;
